import { project2BaseUrl } from './remoteClient'

export async function degreesRequest(token) {
    let res = await project2BaseUrl.get("/administration/getDegrees", {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return res;
}   